<style lang="stylus">
    .slider-dilatancy

        padding: 16px 8px
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);

        .dilatancy-img
            position relative
            margin-bottom 16px
            cursor pointer
            user-select none
            img
                display block
                width 100%
                object-fit contain

            .dilatancy-imgtext
                display flex
                flex-wrap wrap
                align-content space-between
                position absolute
                left 0
                top 0
                width 100%
                height 100%
                padding 12px
                color #fff
                font-size 12px

                span
                    display block

                .dilatancy-imgtext-space
                    font-weight 700
                    margin-bottom 12px
                    font-size 14px
                    text-shadow 0px 3px 20px rgba(224, 151, 0, 0.8)

                .dilatancy-imgtext-buy
                    font-weight 400
                    font-size 12px

                &.dilatancy-imgtext-en
                    .dilatancy-imgtext-space
                        line-height 12px
                        font-size 12px
                        margin-bottom 0

                &.dilatancy-imgtext-langfit
                    padding 4px 8px


        .dilatancy-title
            display flex
            justify-content space-between
            align-items center
            .title-section
                display flex
                align-items center
            .title-tip
                font-size 12px
                color #DD7A07
                line-height 16px
                cursor pointer
                &:hover
                    opacity 0.8
            .cloud-icon
                margin-right 8px
            .dilatancy-text
                display flex
                font-size 12px
                line-height 16px
                span
                    font-size 12px
                    color $right-view-content-textcolor
                    line-height 14px
                .dilatancy-used
                    color #017fff

        .dilatancy-bar
            margin-top 8px
            height 6px
            background rgba(0, 0, 0, 0.06)
            border-radius 4px
            overflow hidden
            .process-inner
                height 6px
                border-radius 4px

    .dark-theme__dilatancy
        .dilatancy-title
            .dilatancy-text
                span
                    color #fff
        .dilatancy-bar
            background rgba(255, 255, 255, .1)
    @media screen and (max-height: 550px)
        .slider-dilatancy
            display none
</style>

<template>
    <div class="slider-dilatancy" :class="{ 'dark-theme__dilatancy': isPCDarkMode == 2 }" style="100%">
        <!-- <div class="dilatancy-img" @click="tobuy" v-if="!vip && showDilatancy && (internal || lang != 'en' || isPC || !isBlackFriday || fuser)">
            <img :src="require(`@/home/assets/img/dilatancy-${isPC ? 'pc' : 'online'}.png`)" draggable="false" alt="">
            <p class="dilatancy-imgtext" :class="{'dilatancy-imgtext-en': !internal || lang != 'zh', 'dilatancy-imgtext-langfit': langFit}">
                <span class="dilatancy-imgtext-space">{{ $t('moreSpace') }}</span>
                <span class="dilatancy-imgtext-buy">{{ $t('toVip') }}</span>
            </p>
        </div>
        <div class="dilatancy-img"  v-if="!internal && lang == 'en' && !isPC && isBlackFriday && !fuser" @click="toBlackFriday">
            <img :src="require(`@/home/assets/img/black_friday_bottom.png`)" draggable="false" alt="">
        </div> -->
        <div class="dilatancy-title">
            <div class="title-section">
                <img class="cloud-icon" :src="require('@/home/assets/img/user/topbar/expand/cloud.svg')" alt="" />
                <div class="dilatancy-text">
                    <span class="dilatancy-used" :style="{ color: textColor }">{{ usedDilatancy }}</span>
                    <span>/</span>
                    <span class="dilatancy-total">{{ maxDilatancy }}</span>
                </div>
            </div>
            <div
                class="title-section title-tip"
                @click="tobuy"
                v-if="!vip && showDilatancy && (internal || lang != 'en' || isPC || !isBlackFriday || fuser)"
            >
                <span class="text-ellipsis" :title="$t('toUpgrade')" style="max-width: 70px">{{ $t("toUpgrade") }}</span>
                <img :src="require('@/home/assets/img/user/topbar/expand/upgrade.svg')" alt="" style="margin-top: -2px" />
            </div>
        </div>
        <div class="dilatancy-bar" style="width: 100%">
            <div class="process-inner" :style="{ width: `${100 * barRatio}%`, 'background-color': barColor }"></div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Vue } from "vue-property-decorator";

    @Component
    export default class Dilatancy extends Vue {
        used_storage = null;
        max_storage = NaN;
        isBlackFriday = false;
        get userInfo() {
            return this.$store.state.userInfo || this.$store.state.user.userInfo;
        }
        get showDilatancy() {
            return !this.isTeamsApp && this.userInfo && this.userInfo.islogin && this.used_storage !== null;
        }
        get usedDilatancy() {
            return ((this.used_storage || 0) / 1024 / 1024).toFixed(2) + "M";
        }
        get maxDilatancy() {
            // return ((this.max_storage || 0) / 1024 / 1024).toFixed(2) +'M'
            let storage = this.max_storage || 0;
            let storageInMB = storage / 1024 / 1024;

            let storageStr = "";
            if (storageInMB >= 1024) {
                let storageInGB = storageInMB / 1024;
                storageStr = storageInGB.toFixed(2) + "G";
            } else {
                storageStr = storageInMB.toFixed(2) + "M";
            }
            return storageStr;
        }
        get barRatio() {
            return this.used_storage / this.max_storage;
        }
        get barWidth() {
            return;
        }
        get barColor() {
            return this.barRatio >= 0.8 ? "#FD6969" : "#017FFF";
        }
        get textColor() {
            return this.barRatio >= 0.8 ? "#FD6969" : this.isPCDarkMode == 2 ? "#ffffff" : "#017fff";
        }
        get langFit() {
            return !this.internal && ["fr", "it"].includes(this.lang);
        }

        get isPCDarkMode() {
            return this.$store.state.isPCDarkMode;
        }

        getStorage() {
            if (!this.userInfo || !this.userInfo.islogin) return;
            this.$edApi
                .getUserInfo({
                    id: this.userInfo.user_id,
                    token: this.userInfo.token,
                })
                .then((res) => {
                    this.used_storage = res?.data?.used_storage;
                    this.max_storage = res?.data?.max_storage;
                });
        }
        toBlackFriday() {
            window.open(
                "https://www.edrawsoft.com/shop/edraw-sales-promotion.html?utm_source=link_in_product_online&utm_medium=productmax&utm_campaign=edraw-black-friday-en2023&utm_term=167*110&utm_content=button_21113677_2023-11-30"
            );
        }
        tobuy() {
            this.$openBuyPage("cloudSpaceLeftBottom");
        }

        created() {}
        mounted() {
            this.$bus.$on("refreshEv", () => {
                this.getStorage();
            });
            this.$bus.$on("getStorage", () => {
                this.getStorage();
            });
            // this.$bus.$on("loginSucc",()=>{
            //     this.getStorage();
            // })
            this.getStorage();
            this.isBlackFriday = new Date().getTime() < new Date("2023-11-30 23:59:59").getTime();
        }

        beforeDestroy() {
            this.$bus.$off("refreshEv");
            this.$bus.$off("getStorage");
        }
    }
</script>
<i18n>
{
    "zh": {
        "moreSpace": "需要更多云空间？",
        "toVip": "点此开通VIP",
        "toUpgrade": "升级"
    },
    "en": {
        "moreSpace": "Need more Cloud Storage?",
        "toVip": "Buy Now",
        "toUpgrade": "Upgrade Now"
    },
    "fr": {
        "moreSpace": "Vous avez besoin de plus de stockage dans le cloud ?",
        "toVip": "Acheter Maintenant",
        "toUpgrade": "Mettez à jour"
    },
    "de": {
        "moreSpace": "Benötigen Sie mehr Cloud-Speicher?",
        "toVip": "Jetzt upgraden",
        "toUpgrade": "Jetzt Aktualisieren"
    },
    "jp": {
        "moreSpace": "クラウドストレージがさらに必要ですか？",
        "toVip": "アップグレード",
        "toUpgrade": "今すぐアップデート"
    },
    "es": {
        "moreSpace": "¿Necesita más almacenamiento en la nube?",
        "toVip": "Actualizar Ahora",
        "toUpgrade": "Actualizar"
    },
    "pt": {
        "moreSpace": "Precisa de mais armazenamento na nuvem?",
        "toVip": "Atualize Agora",
        "toUpgrade": "Atualize Agora"
    },
    "it": {
        "moreSpace": "Hai bisogno di più spazio di archiviazione su cloud?",
        "toVip": "Aggiorna Ora",
        "toUpgrade": "Aggiorna Ora"
    },
    "tw": {
        "moreSpace": "需要更多雲端儲存空間嗎？",
        "toVip": "升級至 Premium",
        "toUpgrade": "升級"
    },
    "kr": {
        "moreSpace": "더 많은 클라우드 스토리지가 필요하십니까?",
        "toVip": "지금 업그레이드하기",
        "toUpgrade": "업그레이드하기"
    },
    "id": {
        "moreSpace": "Butuh Penyimpanan Cloud lebih besar?",
        "toVip": "Tingkatkan Sekarang",
        "toUpgrade": "Perbarui Sekarang"
    }
}
</i18n>
